module.exports = __webpack_public_path__ + "static/media/time-background-icon.215371d7.svg";